import styled from 'styled-components'

export const CardFormContainer = styled.div``

export const RowContent = styled.div`
    width: 100%;
    display:inline-block;
`
export const ColumnContent = styled.div`
    margin: 4px;
    width: 24.5%;
    float: left;
`

export const ColumnButtonContent = styled.div`
    padding-top: 24px;
    width: 46%;
    float: left;
    justify-content: flex-end;
    display: flex;
`
